

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IAdditionalData } from '../../context/model/index';
import { isPropositionInLock } from '../../utils/dataUtils';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';


type InfoPersoStep7FormData = {
  salaryIndex: number;
  increasedIndex: string;
}

export default function InfoPersoStep7FormComponent() {

  const {
    state: {  proposition, updatedProposition, additionalData },
    dispatch,
  } = useAppState();

  const validationSchema = Yup.object().shape({

  });
  
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
   
  } = useForm<InfoPersoStep7FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      salaryIndex: updatedProposition?.salaryIndex ? updatedProposition?.salaryIndex : undefined,
      increasedIndex: updatedProposition?.increasedIndex ? updatedProposition?.increasedIndex : "",
    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = (data: InfoPersoStep7FormData) => {
    let tempUpdatedPropo = updatedProposition;
    let tempAdditionalData = additionalData ?? {} as IAdditionalData;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.salaryIndex = data.salaryIndex;
      tempUpdatedPropo.increasedIndex = data.increasedIndex;
    }
    let nextUrl = APP_URLS.infoPersoRecapPage;
    if(!proposition?.configuration.canBeAddedBeneficiaries && !proposition?.configuration.hasOfferStep){
      nextUrl = APP_URLS.recapPage;
    }
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo, additionalData: tempAdditionalData});
      navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
    });
  }

  const onPreviousAction = () => {
    if (proposition!.configuration.hasIdentityUploadStep) {
      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoPersoStep6Page});
      navigate({
        pathname: APP_URLS.infoPersoStep6Page,
        search: `?id=${proposition!.propositionId}`,
      });
    } else {
      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoPersoStep5Page});

      navigate({
        pathname: APP_URLS.infoPersoStep5Page,
        search: `?id=${proposition!.propositionId}`,
      });
    }
  }

    return (
                  
      <form style={{width: '100%'}}>
        <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <h2 className='card-title bleu mb-sm'>Saisissez votre rémunération de référence </h2>
            <p className='text pb-sm'>Cette information est nécessaire pour estimer votre cotisation prévisionnelle à votre complémentaire santé obligatoire.</p>
            <div className="form-group mw-100">
                <MgpFormInput
                    label="Traitement indiciaire brut mensuel"
                    id="salaryIndex"
                    labelFontWeight='regular'
                    icon="euro"
                    iconPosition="right"
                    register={register} 
                    //errors={errors}
                    //required={true}
                />
            </div>
            <p className='text pb-sm'>Je ne connais pas ma rémunération</p>
            <div className="form-group mw-100">
                <MgpFormInput
                    label="Indice majoré"
                    id="increasedIndex"
                    labelFontWeight='regular'
                    register={register} 
                    //errors={errors}
                    //required={true}
                />
            </div>
          </div>

          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>

          </div>
        </div>
         {proposition && isPropositionInLock(proposition) ? (<StickButtonsBloc disabledPreviousButton={true} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>) : (<StickButtonsBloc showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>)}  
       
      
      </form>
      
  )
}
